import appConfig from '../../config/app';
import { getAuthHeaders } from '../fetchers/auth';

/*
@param {Object} disableConfig
disabled_user: {
  user_id: number
  reason: string
  disabled_by_id: number
}
*/

export async function disableUser(disableConfig, admin_uuid) {
  const options = await getAuthHeaders();
  try {
    const res = await fetch(
      `${appConfig.baseApiUrl}/api/v1/admin/disable_user`,
      {
        method: 'POST',
        headers: {
          ...options,
        },
        body: JSON.stringify(disableConfig),
      },
    );

    return await res.json();
  } catch (error) {
    console.log(error);
  }
}
